/// <amd-module name="Build/Admin/Common/SignalRHubBase" />
import { IHubHostInformation, IHubListener, ISignalRHubOptions, SignalRHub } from "VSS/Features/SignalR/Hub";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";
import { IVssPageContext } from "VSS/Platform/Context";

import { getDTProxyToRegister } from "DistributedTask/Common/SignalR/SignalRHubProxies";

import { SignalRActions } from "Build/Admin/Common/Actions/SignalRActions";
import { SignalRState } from "Build/Admin/Common/Stores/SignalRStore";

const userInactivityTimeoutMs = 1 * 60 * 60 * 1000; // 1 hour

export interface ISignalRHubOptionsBase {
    hostInformation: IHubHostInformation;
    signalRActions: SignalRActions;
    pageContext: IVssPageContext;
    removeApiPath?: boolean;
}

export class SignalRHubBase<TClient, TServer, TOptions extends ISignalRHubOptionsBase> extends SignalRHub<TClient, TServer> implements IHubListener {
    protected options: TOptions;
    protected hubName: string;
    protected listenTimer: number | undefined;
    protected subscribePromise: Promise<void> | undefined;

    constructor(hubName: string, options: TOptions) {
        super({
            name: hubName,
            pageContext: options.pageContext,
            hostInformation: options.hostInformation,
            userInactivityTimeoutMs: userInactivityTimeoutMs,
            proxyToRegister: getDTProxyToRegister,
            removeApiPath: options.removeApiPath
        } as ISignalRHubOptions<TClient, TServer>);

        this.options = options;
        this.hubName = hubName;
    }

    public get hub(): ISignalRHubProxy<TClient, TServer> | null {
        return this.getHub(this.hubName);
    }

    public clearTimer(): void {
        if (this.listenTimer) {
            clearTimeout(this.listenTimer);
        }
    }

    public isConnecting(): void {
        this.options.signalRActions.signalRStateUpdated.invoke(SignalRState.Connecting);
    }

    public isConnected(): void {
        this.options.signalRActions.signalRStateUpdated.invoke(SignalRState.Connected);
    }

    public isDisconnected(): void {
        this.options.signalRActions.signalRStateUpdated.invoke(SignalRState.Disconnected);
    }

    public isReconnected(): void {
        this.options.signalRActions.signalRStateUpdated.invoke(SignalRState.Connected);
    }

    public isReconnecting(): void {
        this.options.signalRActions.signalRStateUpdated.invoke(SignalRState.Connecting);
    }

    public isSlow(): void {
        // do nothing
    }

    public isUserActive(): void {
        // do nothing
    }

    public isUserInactive(): void {
        // do nothing
    }
}
